module.exports = __webpack_public_path__ + "img/cards-left.222ed185.png";